import React from "react";
import "./skelton.scss";

const SkeltonElement = ({ style }: any) => {
  const classes = `skeleton-box`;
  return <div style={{ ...style }} className={classes}></div>;
};

export default SkeltonElement;
